import {Injectable} from "@angular/core";
import {FirebaseAuthService} from "./services/auth/firebase-auth.service";

@Injectable()
export class AppConfigService {

  public version: string;
  public apiEndpointSomeData: string;

  constructor(
    private firebaseAuthService: FirebaseAuthService
  ) {}

  load()  {
    return new Promise(async (resolve, reject) => {
      const unsubscribe = await this.firebaseAuthService.angularFireAuth.onAuthStateChanged(user => {
        unsubscribe();
        resolve(user);
      }, reject);
    });
  }
}
